import { type RefObject } from 'react';

import { downloadBlob } from '@backrs_ui/grow-ui/src/utils/downloadFile';

import { toBlob } from 'html-to-image';

/** Scale of a captured image relative to the element on screen. */
export const CAPTURE_PIXEL_RATIO = 3;

const EXPORT_IGNORE_ATTR = 'data-export-ignore';

/** Spread onto an element to leave it out of a captured image. */
export const exportIgnoreProps = { [EXPORT_IGNORE_ATTR]: true };

const pngBlob = async (ref: RefObject<HTMLElement>): Promise<Blob> => {
  if (!ref.current) throw new Error('chartImage: nothing to capture');

  const blob = await toBlob(ref.current, {
    pixelRatio: CAPTURE_PIXEL_RATIO,
    filter: (node) => !(node instanceof HTMLElement && node.hasAttribute(EXPORT_IGNORE_ATTR)),
  });

  if (!blob) throw new Error('chartImage: capture produced no image');

  return blob;
};

export const copyElementImage = async (ref: RefObject<HTMLElement>): Promise<boolean> => {
  try {
    // Safari only allows the write while the click is still active, so the
    // item is built now with a pending blob rather than after capturing.
    await navigator.clipboard.write([new ClipboardItem({ 'image/png': pngBlob(ref) })]);

    return true;
  } catch (err) {
    console.error('copyElementImage: clipboard write failed', err);

    return false;
  }
};

const fileName = (title: string) =>
  `${
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'chart'
  }.png`;

export const downloadElementImage = async (
  ref: RefObject<HTMLElement>,
  title: string,
): Promise<boolean> => {
  try {
    downloadBlob(await pngBlob(ref), fileName(title));

    return true;
  } catch (err) {
    console.error('downloadElementImage: capture failed', err);

    return false;
  }
};
